import React from 'react';
import { PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';

const MyPie = ({data}) => {
    return (
        <PieChart width={400} height={400}>
            <Pie
                data={data}
                cx={200}
                cy={200}
                labelLine={false}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            >
                {
                    data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.fill} />
                    ))
                }
            </Pie>
            <Tooltip />
            <Legend />
        </PieChart>
    );
};

export default MyPie;
